/*
 * @Author: Duanjiaojiao
 * @Date: 2022-06-21 10:41:31
 * @LastEditors: Duanjiaojiao
 * @LastEditTime: 2023-04-06 10:34:26
 * @Description: 项目中的所有枚举
 * @FilePath: /BM-Main/src/conf/enum.conf.js
 * @props:
 */

export const MODEL_PAGE_SCENE_MAP = {
  NORMAL: '1642716038757880338', // 正常流程
  NORMAL_ZLJ: '1658705758553903146', // 找靓机正常流程
  RECYCLE_CAR: '1658818943134994959', // 回收车
  OLD_TO_NEW: '1658796140226678877', // 以旧换新
  OLD_TO_CASH: '1648587539327488521', // 以旧折扣购
  GAO_DE: '1663011287300313647', // 高德
  KUAI_SHOU: '1688432590341541972', // 快手
  BLIND_BOX_RECYCLE: '1990260512620810330', // 盲盒聚合搜索页
  ONE_CLICK_D2D: '2000765186973111322' // 一键上门回收车
}

export const CATE_MAP = {
  PHONE: 101, // 手机
  PAD: 119, // 平板
  MAC: 1100000016, // 笔记本
  EYEPHONE: 1100000186, // 耳机
  GAME: 2123001 // 游戏
}

export const DELIVERY_TYPE = {
  SF: 1, // 顺丰
  SELF_SEND: 2, // 自己寄
  STORE: 3, // 门店
  STORE_HOME: 4, // 门店上门
  ZLJ_HOME: 5 // 履约上门
}

export const CREATE_ORDER_TYPE = {
  PHONE_PAD_SF: 2, // 手机、平板顺丰取件
  PHONE_PAD_SELF: 3, // 手机、平板自行寄件
  LAPTOP_DIGITAL_SF: 6, // 笔记本、智能数码顺丰取件
  LAPTOP_DIGITAL_SELF: 7, // 笔记本、智能数码自行寄件
  AGGREGATE_RECYCLE_SF: 13 // 聚合回收品类 顺丰取件，无自己寄
}

export const CREATE_ORDER_MAP = {
  ZZ_SF: 1, // 转转_邮寄_预约上门
  ZZ_SELF: 2, // 转转_邮寄_自行邮寄
  ZLJ_SF: 3, // 找靓机_邮寄_预约上门
  ZLJ_SELF: 4, // 找靓机_邮寄_自行邮寄

  D2D_STANDER: 5, // 转转_上门_标准下单
  D2D_INCREMENT: 6, // 转转_上门_增量下单
  ZLJ_D2D_STANDER: 7, // 找靓机_上门_标准下单
  ZLJ_D2D_INCREMENT: 8, // 找靓机_上门_增量下单

  SF_RECYCLE_CAR: 9, // 转转_邮寄_预约上门_回收车下单,
  SELF_RECYCLE_CAR: 10, // 转转_邮寄_自行寄件_回收车下单,
  ZLJ_SF_RECYCLE_CAR: 11, // 找靓机_邮寄_预约上门_回收车下单,
  ZLJ_SELF_RECYCLE_CAR: 12, // 找靓机_邮寄_自行寄件_回收车下单,
  SF_WORTH_RECYCLE_CAR: 13, // 转转_邮寄_预约上门_身价活动_回收车下单
  D2D_RECYCLE_CAR: 14, // 转转_上门_回收车下单,
  ZLJ_D2D_RECYCLE_CAR: 15, // 找靓机_上门_回收车下单,
  D2D_VAN_RECYCLE_CAR: 40, // 转转_上门_回收车下单_四轮车下单,

  ZZ_D2D_OLD_2_NEW: 16, // 转转_上门_以旧换新,
  ZLJ_D2D_OLD_2_NEW: 17, // 找靓机_上门_以旧换新,

  SF_AGGREGATE_RECYCLE: 18, // 转转_邮寄_预约上门_聚合回收,
  D2D_AGGREGATE_RECYCLE: 32, // 转转_上门_聚合回收
  ZLJ_SF_AGGREGATE_RECYCLE: 19, // 找靓机_邮寄_预约上门_聚合回收,
  ZZ_D2D_AGGREGATE_RECYCLE_INCR: 33, //转转_上门_聚合回收_增单
  ZLJ_D2D_AGGREGATE_RECYCLE: 34, //找靓机_上门_聚合回收
  ZLJ_D2D_AGGREGATE_RECYCLE_INCR: 35, //找靓机_上门_聚合回收_增单

  SF_CREDIT_RECYCLE: 20, // 转转_邮寄_预约上门_信用回收,
  SELF_CREDIT_RECYCLE: 21, // 转转_邮寄_自行寄件_信用回收,
  PRE_SELF_CREDIT_RECYCLE: 22, // 转转_预下单_邮寄_自行寄件_信用回收
  PRE_SF_CREDIT_RECYCLE: 23, // 转转_预下单_邮寄_顺丰上门_信用回收

  ADDITIONAL_RECYCLE_CAR: 30, // 待发货订单-追加物品
  BLIND_BOX_RECYCLE_CAR: 43, // 盲盒回收车
  OLD_CLOTHES_RECYCLE_CAR: 43, // 旧衣回收车
  MERGE_ORDER_RECYCLE_CAR: 44, // 合并提单回收车
  ONE_CLICK_D2D_RECYCLE_CAR: 50 // 一键上门回收车
}

export const RECYCLE_CAR_MAP = {
  NORMAL_CAR: 4, // 常规场景回收车
  WORTH_CAR: 2, // 身价活动回收车
  DOUBLE_ELEVEN_ACTIVITY: 3, // 双11活动回收车
  ORDER_CAR: 5, // 回收车大促活动+多单补贴
  COMBO_CAR: 6, // 套机场景回收车
  VAN_RECYCLE_CAR: 7, // 转转_上门_回收车下单_四轮车下单
  BLIND_BOX_RECYCLE_CAR: 8, // 盲盒回收车
  MERGE_ORDER_RECYCLE_CAR: 9, // 合并提单多履约回收车
  OLD_CLOTHES_RECYCLE_CAR: 11, // 旧衣回收车
  ONE_CLICK_D2D_RECYCLE_CAR: 10 // 一键上门回收车
}

export const SEND_RECYCLE_MAP = { // 邮寄回收类型
  Normal: 0, // 普通回收
  Zhima: 1 // 信用回收
}

// 上门交易方式展示枚举 地址>gps>ip
export const D2D_SHOW_MAP = {
  DEFAULT: 0, // 上门模块的兜底展示，兼容小程序、抖音快手等，不走以下逻辑
  HAS_ADDRESS_AND_CAN_D2D: 1, // 有地址且符合上门
  HAS_ADDRESS_BUT_OUT_MODEL: 2, // 有地址但机况不合符上门
  HAS_ADDRESS_BUT_OUT_AREA: 3, // 有地址但地址不符合上门
  NO_ADDRESS_HAS_GPS_AND_CAN_D2D: 4, // 无地址有gps且gps命中上门 (后端实验21686，增加优先判断gps命中逻辑，4可能有默认地址，有地址就跳转地址列表 ，没有地址就跳转新增)
  NO_ADDRESS_HAS_GPS_BUT_OUT_MODEL: 5, // 无地址有gps但机况不符合上门  展示图片
  NO_ADDRESS_HAS_GPS_BUT_OUT_AREA: 6, // 无地址有gps但gps不符合上门
  NO_ADDRESS_NO_GPS: 7, // 无地址无gps，ip命中上门
  NO_ADDRESS_NO_GPS_HAS_IP_BUT_OUT_MODEL: 8, // 无地址无gps有ip，但机况不符合上门
  NO_ADDRESS_NO_GPS_HAS_IP_BUT_OUT_AREA: 9, // 无地址无gps有ip，但ip不符合上门
  HAS_ADDRESS_BUT_OUT_AREA_HAS_GPS_CAN_D2D: 10, // 有地址但地址不符合上门，有gps且gps命中上门
  HAS_ADDRESS_BUT_OUT_AREA_HAS_GPS_BUT_OUT_MODEL: 11, // 有地址但地址不符合上门，有gps但机况不符合上门，展示同2
  HAS_ADDRESS_BUT_OUT_AREA_HAS_GPS_BUT_OUT_AREA: 12 // 有地址但地址不符合上门，有gps但gps不符合上门，展示同3
}
